const Directive = {
    BlurEven: {
        install: function (Vue) {
            Vue.directive('blur', {
                inserted (el) {
                    el.addEventListener('focusout', () => {
                        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                            setTimeout(() => {
                                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
                                window.scrollTo(0, Math.max(scrollHeight - 1, 0))
                            }, 100)
                        }
                    })
                }
            })
        }
    }
}
export default Directive
